import * as React from "react";

import "./style.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux";
import ReactPaginate from "react-paginate";
import { Product, Size } from "../../../../gobalType";

import { Box } from "@mui/material";
import { ProductPlantsListSkeleton } from "../../../../components/skeletons/AppPageSkeletons";
import ItemSize from "./ItemSize";

interface ProductCardProps {
  selectedSizes?: string[];
  /** Bắt buộc ở trang plants: map `sizes` (value) với tên size trên từng sản phẩm. */
  allSize?: Size[];
  /** 1 = plants, 2 = pots — dùng khi list API thiếu `product.category_id`. */
  listCategoryId?: 1 | 2;
}
const ProductCard = ({
  selectedSizes = [],
  allSize = [],
  listCategoryId,
}: ProductCardProps) => {
  const { product_lists, loadingPf } = useSelector(
    (state: RootState) => state?.products
  );

  const [currentPage, setCurrentPage] = React.useState(0);
  const normalizedSelectedSizes = selectedSizes
    .filter((size) => size !== "all")
    .map((size) => size.toLowerCase());

  const PageSize = 10;

  const indexOfLastItem = (currentPage + 1) * PageSize;
  const indexOfFirstItem = indexOfLastItem - PageSize;
  let currentItems;
  if (product_lists?.length > 0) {
    currentItems = product_lists?.slice(indexOfFirstItem, indexOfLastItem);
  }

  const handlePageClick = (products: Product | any) => {
    setCurrentPage(products.selected);
  };

  if (loadingPf) {
    return (
      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
        }}>
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
          }}
          className="info-products__heading">
          <Box className="title-heading">
            <Box className="title-plant">NAME</Box>
            <Box className="title-value-size">AVAILABILITY</Box>
            {normalizedSelectedSizes.length > 0 && (
              <Box className="title-action">QTY</Box>
            )}
          </Box>
        </Box>
        <Box
          className="container-size"
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            boxSizing: "border-box",
          }}>
          <ProductPlantsListSkeleton omitDesktopHeadingStrip />
        </Box>
      </Box>
    );
  }
  return (
    <>
      {product_lists?.length > 0 ? (
        <Box
          sx={{
            width: { xs: "100%", sm: "100%", md: "100%" },
            maxWidth: "100%",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: { xs: "none", sm: "block" },
            }}
            className="info-products__heading">
            <Box className="title-heading">
              <Box className="title-plant">NAME</Box>

              <Box className="title-value-size">AVAILABILITY</Box>
              {normalizedSelectedSizes.length > 0 && (
                <Box className="title-action">QTY</Box>
              )}
            </Box>
          </Box>
          <Box
            className="container-size"
            sx={{
              width: "100%",
              minWidth: 0,
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            {currentItems?.map((item, index) => {
              return (
                <ItemSize
                  key={item?.id ?? index}
                  item={item}
                  selectedSizes={normalizedSelectedSizes}
                  allSize={allSize}
                  listCategoryId={listCategoryId}
                />
              );
            })}
          </Box>
        </Box>
      ) : (
        <Box sx={{ fontSize: { xs: 15, sm: 18 } }} className="data-empty">
          No data!
        </Box>
      )}

      {product_lists?.length > PageSize && (
        <ReactPaginate
          previousLabel={"Previous"}
          nextLabel={"Next"}
          breakLabel={"..."}
          pageCount={Math.ceil(product_lists?.length / PageSize)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </>
  );
};
export default ProductCard;
